// // // src/App.jsx
// // import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// // import { AuthProvider } from "./hooks/useAuth";
// // import ProtectedRoute from "./components/ProtectedRoute";
// // import LandingPage from "./pages/LandingPage";
// // import LoginPage from "./pages/LoginPage";
// // import SignupPage from "./pages/SignupPage";
// // import DashboardPage from "./pages/DashboardPage";
// // import SupportPage from "./pages/SupportPage";
// // import ProfilePage from "./pages/ProfilePage";
// // import ForgotPasswordPage from "./pages/ForgotPasswordPage";
// // import FreeResumeGeneration from "./pages/FreeResumeGeneration";
// // import VerifyEmailPage from "./pages/VerifyEmailPage";

// // export default function App() {
// //   return (
// //     <AuthProvider>
// //       <BrowserRouter>
// //         <Routes>
// //           <Route path="/" element={<LandingPage />} />
// //           <Route path="/login" element={<LoginPage />} />
// //           <Route path="/signup" element={<SignupPage />} />
// //           <Route path="/support" element={<SupportPage />} />
// //           <Route path="/forgot-password" element={<ForgotPasswordPage />} />
// //           <Route path="/resume-generator" element={<FreeResumeGeneration />} />
// //           <Route
// //           path="/profile"
// //           element={
// //             <ProtectedRoute>
// //               <ProfilePage />
// //             </ProtectedRoute>
// //           }
// //         />
// //           <Route
// //             path="/dashboard"
// //             element={
// //               <ProtectedRoute>
// //                 <DashboardPage />
// //               </ProtectedRoute>
// //             }
// //           />
// //           <Route path="*" element={<Navigate to="/" replace />} />
// //         </Routes>
// //       </BrowserRouter>
// //     </AuthProvider>
// //   );
// // }

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./hooks/useAuth";
import ProtectedRoute from "./components/ProtectedRoute";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import DashboardPage from "./pages/DashboardPage";
import SupportPage from "./pages/SupportPage";
import ProfilePage from "./pages/ProfilePage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ResumeGeneratorPage from "./pages/FreeResumeGeneration"
import VerifyEmailPage from "./pages/VerifyEmailPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import AdminPage from "./pages/AdminPage";
import AccountPage from "./pages/AccountPage";
import CoverLetterPage from "./pages/CoverLetterPage";
import ResumeFromScratchPage from "./pages/ResumeFromScratchPage";
import RefundPolicyPage from "./pages/RefundPolicyPage";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms"   element={<TermsOfServicePage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/cover-letter" element={<CoverLetterPage />} />
          {/* Email verification — accessible when logged in but not verified */}
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/build-resume" element={<ResumeFromScratchPage />} />
          <Route path="/refund" element={<RefundPolicyPage />} />
          <Route path="/admin" element={<AdminPage />} />
          {/* Protected routes — require login AND email verified */}
          <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
          <Route path="/generate-resume" element={<ProtectedRoute><ResumeGeneratorPage /></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}